import React from "react";
import { Spinner } from "@chakra-ui/react";
import type { UserListItem } from "../../../types/userInvite";
import { UserListRow } from "./UserListRow";

interface UserListTableProps {
  users: UserListItem[];
  isLoading: boolean;
  onEdit: (user: UserListItem) => void;
  onDeactivate: (user: UserListItem) => void;
}

const COLUMNS = ["Name", "Email", "Role", "Status", "Last activity", "Actions"];

const SkeletonRow: React.FC = () => (
  <tr className="border-b border-gray-200">
    {COLUMNS.map((col) => (
      <td key={col} className="px-4 py-3">
        <div className="h-4 rounded bg-gray-200 animate-pulse" />
      </td>
    ))}
  </tr>
);

const EmptyState: React.FC = () => (
  <tr>
    <td colSpan={COLUMNS.length} className="px-4 py-12 text-center text-sm text-gray-500">
      No users found. Invite someone to get started.
    </td>
  </tr>
);

export const UserListTable: React.FC<UserListTableProps> = ({
  users,
  isLoading,
  onEdit,
  onDeactivate,
}) => (
  <div className="overflow-x-auto">
    <table className="min-w-full divide-y divide-gray-200">
      <thead className="bg-gray-50">
        <tr>
          {COLUMNS.map((col) => (
            <th
              key={col}
              className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 whitespace-nowrap"
            >
              {col}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200 bg-white">
        {isLoading ? (
          <>
            <SkeletonRow />
            <SkeletonRow />
            <SkeletonRow />
          </>
        ) : users.length === 0 ? (
          <EmptyState />
        ) : (
          users.map((user) => (
            <UserListRow
              key={user.id}
              user={user}
              onEdit={onEdit}
              onDeactivate={onDeactivate}
            />
          ))
        )}
      </tbody>
    </table>
  </div>
);
